export default "__VITE_ASSET__x_TEXgwj__"